/**
 * 头部导航栏
 * Created at 2021-09-30 15:57
 * @author teapot
 */
import "./index.css";

import { useState } from "react";
import { Drawer, Dropdown, Image, Menu } from "antd";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { MenuList } from "../../model/NavModel";
import { useHistory } from "react-router";
import { DetailsParams } from "../../model/HomeModel";
import Api from "../../api";
import { locals, setLocal } from "../../i18n";
import { useLocation } from "react-router-dom";
import search from "./image/search.png";
import logo from "./image/1111111.png";

// import facebook from './image/41.png'
import circle from "./image/42.png";
import indas from "./image/43.png";
import tv from "./image/44.png";

import link from "./image/link.png";
import youtu from "./image/youtu.png";
import facebook from "./image/facebook.png";
import is from "./image/is.png";

const { SubMenu } = Menu;
let flag = false;
const Navbar = () => {
  let [flagg, setflagg] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [visible, setVisible] = useState(false); // 定义 左边菜单栏显示
  // 左边菜单栏点击 关闭显示
  const _showDrawer = () => {
    setVisible(true);
  };
  const _onClose = () => {
    setVisible(false);
  };

  // 导航栏 子项数据
  const list = (isPhone?: boolean) => {
    const arr: MenuList[] = [
      {
        id: "us",
        title: t("nav_us"),
        item: [
          {
            id: "outlook",
            title: t("nav_us_outlook"),
          },
          {
            id: "adviser",
            title: t("nav_us_adviser"),
          },
          {
            id: "tinktank",
            title: t("nav_us_think_tank"),
          },

          {
            id: "joinus",
            title: t("nav_us_join"),
          },
          {
            id: "contact",
            title: t("nav_us_contact"),
          },
          {
            id: "linkus",
            title: t("nav_us_link"),
          },
        ],
      },
      {
        id: "multimedia",
        title: t("nav_multimedia"),
        item: [
          {
            id: "media",
            title: t("nav_multimedia_media"),
          },
          {
            id: "news",
            title: t("nav_multimedia_news"),
          },
        ],
      },
      {
        id: "report",
        title: t("nav_report"),
      },
      {
        id: "member",
        title: t("nav_member"),
      },
      {
        id: "policy",
        title: t("nav_policy"),
        item: [
          {
            id: "book",
            title: t("policy_book"),
          },
          {
            id: "review",
            title: t("policy_review"),
          },
        ],
      },
    ];
    // 如果是手机端需要添加首页
    if (isPhone) {
      arr.unshift({
        id: "/",
        title: t("nav_index"),
      });
    }

    return arr;
  };

  const getIndex = (item: MenuList) => {
    if (item.item) {
      for (const value of item.item) {
        if ("/" + value.id === location.pathname) {
          return true;
        }
      }
    }
    return false;
  };

  // 菜单栏 如果是手机端则左侧导航栏 否则横向导航栏
  // 远景及展望是直接跳转到详情页 根据id 判断的
  const _menuView = (item: MenuList[], isPhone?: boolean) => {
    if (isPhone) {
      return (
        <Menu mode="inline">
          {item.map((value, index) => {
            if (value.item) {
              return (
                <SubMenu key={index} title={value.title}>
                  {value.item.map((l) => {
                    return (
                      <Menu.Item
                        key={l.id}
                        onClick={() => {
                          let path = window.btoa(
                            JSON.stringify({
                              url: Api.outlook,
                              uuid: "111",
                              methods: "get",
                              bottom: true,
                            })
                          );
                          switch (l.id) {
                            case "outlook":
                              history.push(
                                `/about-us/mission&convener_statement/${path}`,
                                {
                                  url: Api.outlook,
                                  uuid: "111",
                                  methods: "get",
                                  bottom: true,
                                }
                              );
                              // history.push(
                              //   "/about-us/mission&convener_statement",
                              //   {
                              //     url: Api.outlook,
                              //     uuid: "111",
                              //     methods: "get",
                              //     bottom: true,
                              //   } as DetailsParams
                              // );
                              break;
                            case "adviser":
                              history.push("/about-us/advisory_board ");
                              break;
                            case "tinktank":
                              history.push("/about-us/member");
                              break;
                            case "joinus":
                              history.push("/about-us/join-us");
                              break;
                            case "linkus":
                              history.push("/about-us/related_links");
                              break;
                            case "contact":
                              history.push("/about-us/contact-us");
                              break;

                            case "media":
                              history.push("/newsroom/media_coverage");
                              break;
                            case "news":
                              history.push("/newsroom/press-releases");
                              break;

                            case "book":
                              history.push(
                                "/policy-research/journals-published"
                              );
                              break;
                            case "review":
                              history.push("/policy-research/article-reviews");
                              break;
                          }
                        }}
                      >
                        {l.title}
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              );
            } else {
              return (
                <Menu.Item
                  key={value.id}
                  onClick={() => {
                    if (value.id === "/") {
                      history.push("/");
                      return;
                    }
                    if (value.id === "report") {
                      history.push("/whats_on_neg");
                      return;
                    }
                    if (value.id === "member") history.push("/commentary");
                    return;
                  }}
                >
                  {value.title}
                </Menu.Item>
              );
            }
          })}
        </Menu>
      );
    } else {
      return (
        <Menu defaultSelectedKeys={[location.pathname.replace("/", "")]}>
          {item.map((value) => {
            return (
              <Menu.Item
                className="menu-item-active"
                key={value.id}
                onClick={() => {
                  // console.log(value.id);
                  let path = window.btoa(
                    JSON.stringify({
                      url: Api.outlook,
                      uuid: "111",
                      methods: "get",
                      bottom: true,
                    })
                  );
                  switch (value.id) {
                    case "outlook":
                      history.push(
                        `/about-us/mission&convener_statement/${path}`,
                        {
                          url: Api.outlook,
                          uuid: "111",
                          methods: "get",
                          bottom: true,
                        }
                      );
                      // history.push(
                      //   `/about-us/mission&convener_statement/${path}`,
                      //   {
                      //     url: Api.outlook,
                      //     uuid: "111",
                      //     methods: "get",
                      //     bottom: true,
                      //   } as DetailsParams
                      // );
                      break;
                    case "adviser":
                      history.push("/about-us/advisory_board ");
                      break;
                    case "tinktank":
                      history.push("/about-us/member");
                      break;
                    case "joinus":
                      history.push("/about-us/join-us");
                      break;
                    case "linkus":
                      history.push("/about-us/related_links");
                      break;
                    case "contact":
                      history.push("/about-us/contact-us");
                      break;

                    case "media":
                      history.push("/newsroom/media_coverage");
                      break;
                    case "news":
                      history.push("/newsroom/press-releases");
                      break;

                    case "book":
                      history.push("/policy-research/journals-published");
                      break;
                    case "review":
                      history.push("/policy-research/article-reviews");
                      break;
                  }
                }}
              >
                {value.title}
              </Menu.Item>
            );
          })}
        </Menu>
      );
    }
  };

  // -------------------------------------------------------------------------//
  return (
    <div className="nav nav-column">
      {/* pc 平板 手机横屏导航栏 */}

      <div className="nav-top nav-row-center nav-row-center-title nav-pc">
        <div className="nav-logo">
          <img
            alt={"Logo"}
            src={logo}
            onClick={() => {
              history.replace("/");
            }}
          />
        </div>
        <div className="rightTop">
          <ul className="nav-translate-ul ">
            <li>
              <span
                style={{ cursor: "pointer", color: "#f2bd4c" }}
                id="tranA"
                onClick={() => {
                  setflagg(!flagg);
                  flag = !flag;
                }}
              >
                {localStorage.getItem("i18nextLng") === "zh-CN" ? "简" : "繁"}
              </span>
              <ul>
                <li
                  id="translate"
                  className={
                    flagg ? "nav-translate-active" : "nav-translate-before"
                  }
                >
                  <span
                    style={
                      localStorage.getItem("i18nextLng") === "zh-CN"
                        ? { color: "#f2bd4c" }
                        : {}
                    }
                    onClick={() => {
                      setLocal("zh-CN");
                      history.replace("/");
                    }}
                  >
                    简
                  </span>
                </li>

                <li
                  id="translate"
                  className={
                    flag ? "nav-translate-active" : "nav-translate-before"
                  }
                >
                  {" "}
                  <span
                    style={
                      localStorage.getItem("i18nextLng") === "zh-HK"
                        ? { color: "#f2bd4c" }
                        : {}
                    }
                    onClick={() => {
                      setLocal("zh-HK");
                      history.replace("/");
                    }}
                  >
                    繁
                  </span>
                </li>
              </ul>
            </li>
          </ul>
          {/* <div className="boxoffset">
            <div className="iconoffset">
              {" "}
              <Image preview={false} src={facebook} width={"19px"} />
            </div>
            <div className="iconoffset">
              <Image preview={false} src={is} width={"19px"} />{" "}
            </div>
            <div className="iconoffset">
              <Image preview={false} src={link} width={"19px"} />
            </div>
            <div className="iconoffset">
              {" "}
              <Image preview={false} src={youtu} width={"19px"} />
            </div>
          </div> */}
          <Image
            className="Imagepointer"
            preview={false}
            alt={"搜索"}
            src={search}
            onClick={() => {
              history.push("/search");
            }}
            width={"20px"}
          />
        </div>
        <div className="rightBot-rightBot">
          <div className="iconoffset-rightBot">
            {localStorage.getItem("i18nextLng") === "zh-HK"
              ? "Facebook 主頁名稱：治港新政"
              : "Facebook 主页名称：治港新政"}
          </div>
          <div className="iconoffset-url">
            {localStorage.getItem("i18nextLng") === "zh-HK"
              ? "鏈接："
              : "链接："}
            <Image
              className="iconoffset-url-img"
              preview={false}
              src={facebook}
              width={"19px"}
              onClick={() => {
                window.open("https://www.facebook.com/hknegrc", "_blank");
              }}
            />
          </div>
        </div>
      </div>

      {/* 手机竖屏导航栏 */}
      <div className="nav-top nav-row-center nav-row-center-title nav-phone">
        <MenuUnfoldOutlined
          className="nav-phone-menu"
          onClick={() => _showDrawer()}
        />
        <div className="nav-logo gg">
          <img
            alt={"Logo"}
            src={logo}
            onClick={() => {
              history.replace("/");
            }}
          />
        </div>
        <div className="phoneRight">
          <ul className="nav-translate-ul ">
            <li>
              <span
                style={{ cursor: "pointer", color: "#f2bd4c" }}
                id="tranA"
                onClick={() => {
                  setflagg(!flagg);
                }}
              >
                {localStorage.getItem("i18nextLng") === "zh-CN" ? "简" : "繁"}{" "}
              </span>
              <ul>
                <li
                  id="translate"
                  className={
                    flagg ? "nav-translate-active" : "nav-translate-before"
                  }
                >
                  <span
                    style={
                      localStorage.getItem("i18nextLng") === "zh-CN"
                        ? { color: "#f2bd4c" }
                        : {}
                    }
                    onClick={() => {
                      setLocal("zh-CN");
                      history.replace("/");
                    }}
                  >
                    简
                  </span>
                </li>

                <li
                  id="translate"
                  className={
                    flagg ? "nav-translate-active" : "nav-translate-before"
                  }
                >
                  {" "}
                  <span
                    style={
                      localStorage.getItem("i18nextLng") === "zh-HK"
                        ? { color: "#f2bd4c" }
                        : {}
                    }
                    onClick={() => {
                      setLocal("zh-HK");
                      history.replace("/");
                    }}
                  >
                    繁
                  </span>
                </li>
              </ul>
            </li>
          </ul>

          <Image
            preview={false}
            alt={"搜索"}
            src={search}
            onClick={() => {
              history.push("/search");
            }}
            width={"15px"}
          />
        </div>
      </div>

      {/* pc 菜单栏 */}
      <div className="nav-pc nav-row-center nav-pc-color">
        {list().map((item, index) => {
          if (item.item) {
            return (
              <div className="nav-row-center-item" key={index}>
                <Dropdown
                  overlayClassName={"itemClass"}
                  overlay={_menuView(item.item)}
                >
                  <div className="nav-row-center-item">
                    <div
                      className={"nav-row-center-item-title"}
                      style={
                        getIndex(item)
                          ? {
                              fontSize: "20px",
                              color: "#7e6936",
                            }
                          : {}
                      }
                    >
                      {item.title}
                    </div>
                  </div>
                </Dropdown>
              </div>
            );
          } else {
            return (
              <div
                className="nav-row-center-item"
                key={index}
                onClick={() => {
                  if (item.id === "report") {
                    history.push("/whats_on_neg");
                    return;
                  }
                  if (item.id === "member") history.push("/commentary");
                  return;
                }}
              >
                <div
                  className={"nav-row-center-item-title"}
                  style={
                    location.pathname === "/" + item.id
                      ? {
                          fontSize: "20px",
                          color: "#7e6936",
                        }
                      : {}
                  }
                >
                  {item.title}
                </div>
                <div
                  // className='nav-row-center-item-active-line'
                  style={
                    location.pathname === "/" + item.id
                      ? {
                          backgroundColor: "#7e6936",
                        }
                      : {}
                  }
                />
              </div>
            );
          }
        })}
      </div>

      {/* 手机 菜单栏 抽屉 */}
      <Drawer
        closable={false}
        bodyStyle={styles}
        placement="left"
        onClose={_onClose}
        visible={visible}
      >
        <div className="nav-h-line" />
        {_menuView(list(true), true)}
      </Drawer>
    </div>
  );
};

export default Navbar;

const styles = {
  padding: 0,
  backgroundColor: "#F8F8F8",
};
